/* eslint-disable prettier/prettier */
/* eslint-disable no-var */
/* eslint-disable prefer-rest-params */
// @ts-nocheck
import React, { useEffect } from 'react';
import analytics from '@common/utils/analytics';
import useBreakpoint from '@utils/useBreakpoint';
import api from '@utils/api';
const sendAnalytics = () => {
    var _a;
    let masterId = (_a = window.datalayerdata) === null || _a === void 0 ? void 0 : _a.masterId;
    return analytics.openLiveChat(masterId);
};
const ChatSprinklr = (props) => {
    const currentBreakpoint = useBreakpoint();
    useEffect(() => {
        if (window.loggedin && props.user) {
            api.GetSprinklrUserData(window.country, window.language).then((response) => {
                if (response.success) {
                    if (response.data && response.data.hash) {
                        initSprinklr(response.data);
                    }
                    else {
                        console.error('User Data found but no hash is generated: missing configuration for sprinkler key or for livechat language and country');
                    }
                }
                else {
                    console.error(response.error);
                }
            });
        }
        else {
            initSprinklr();
        }
    }, []);
    const initSprinklr = (userData) => {
        window.sprChatSettings = { appId: props.sprinklrappid, skin: 'MODERN', clientContext: { "_c_651be15a5290a2658245b658": "Website" }, user: userData };
        (function () {
            var t = window, e = t.sprChat, a = e && !!e.loaded, n = document, r = function () {
                r.m(arguments);
            };
            (r.q = []),
                (r.m = function (t) {
                    r.q.push(t);
                }),
                (t.sprChat = a ? e : r);
            let o = function () {
                let e = n.createElement('script');
                (e.type = 'text/javascript'),
                    (e.async = !0),
                    (e.src = 'https://prod3-live-chat.sprinklr.com/api/livechat/handshake/widget/' + t.sprChatSettings.appId),
                    (e.onerror = function () {
                        t.sprChat.loaded = !1;
                    }),
                    (e.onload = function () {
                        t.sprChat.loaded = !0;
                        const handleChatAvailability = (e) => {
                            console.info('handleSprinklrAvailability: ', e);
                        };
                        t.sprChat("onAvailabilityChange", handleChatAvailability);
                        t.sprChat("offAvailabilityChange", handleChatAvailability);
                        document.querySelectorAll('.chat-button:not(disabled)').forEach((el) => el.addEventListener('click', () => window.sprChat && window.sprChat('open')));
                    });
                t.sprChat("onEvent", (e) => {
                    var _a;
                    if (e.eventType === "CHAT_TRIGGER_CLICKED" && ((_a = window.datalayerdata) === null || _a === void 0 ? void 0 : _a.pageCategory) == 'pdp') {
                        sendAnalytics();
                    }
                    if (currentBreakpoint <= window.mqObj.sm) {
                        const removeOverflow = document.body.classList.contains('no-overflow');
                        if (e.eventType === "CHAT_TRIGGER_CLICKED" && !removeOverflow) {
                            document.body.classList.add('no-overflow');
                        }
                        else if (e.eventType === "CONVERSATION_WINDOW_CLOSED" && removeOverflow) {
                            document.body.classList.remove('no-overflow');
                        }
                    }
                });
                let a = n.getElementsByTagName('script')[0];
                a.parentNode.insertBefore(e, a);
            };
            'function' == typeof e ? (a ? e('update', t.sprChatSettings) : o()) : 'loading' !== n.readyState ? o() : n.addEventListener('DOMContentLoaded', o);
        })();
    };
    return React.createElement("div", { className: "sprinklrChat-enable" });
};
export default ChatSprinklr;
